/**
 * PAYROLL PREP, SECTION BY SECTION, AND THE KEY EACH ONE'S API CHECKS.
 *
 * The page has no key of its own: each section reads its own endpoint, and the
 * API gates each one on its own view key (packages/api/src/routes/reports.routes.ts —
 * `/allowances`, `/deductions`, `/loans`, `/reports/payslip`). So the page is
 * open to whoever can read at least one section, and shows that person exactly
 * those sections. It was gated on the login role (ADMIN/HR), which let a
 * narrower access role on an HR base in and kept a role granted the keys out.
 */
export const PAYROLL_PREP_SECTION_KEYS = {
  allowances: 'pay.allowances.view',
  deductions: 'pay.deductions.view',
  loans: 'pay.loans.view',
  payslips: 'reports.payslip.view',
} as const;

/** Any one of these opens the page (nav row and route). */
export const PAYROLL_PREP_VIEW_KEYS: readonly string[] = Object.values(PAYROLL_PREP_SECTION_KEYS);
